var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDocsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 550,
    viewBox: "0 0 400 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0H37.5C17.5 0 0 17.5 0 37.5V512.5C0 532.5 17.5 550 37.5 550H362.5C382.5 550 400 532.5 400 512.5V150L312.5 87.5L250 0Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 400H300V375H100V400ZM100 450H250V425H100V450ZM100 275V300H300V275H100ZM100 350H300V325H100V350Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0V112.5C250 132.5 267.5 150 287.5 150H400L250 0Z",
    fill: "#A1C2FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocsIcon);
export default __webpack_public_path__ + "static/media/google-docs-icon.91223a60437527d2a7bdafb6d05f5c66.svg";
export { ForwardRef as ReactComponent };